<div class="row">
  <form class="needs-validation container-style" [formGroup]="formEquipmentLogbook">
    <div class="ps-2 pe-2 pb-2">
      <div class="row mb-2">
        <div class="col-md-7 col-12">
          <div class="row">
            <div class="col-lg-1 col-md-2 col-sm-2 col-4">
              <app-custom-input-text formControlName="consecutive" [labelText]="'Número'"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-5 col-8">
              <app-custom-autocomplete formControlName="providerId" [labelText]="'Proveedor'" [list]="listProviders"
                [required]="true"></app-custom-autocomplete>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-2 col-4">
              <app-custom-input-text formControlName="invoiceNumber" [labelText]="'Nro.Fra.Compra'"
                [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3 col-4">
              <app-custom-datepicker formControlName="purchaseDate" [labelText]="'Fecha Compra'"
                [required]="true"></app-custom-datepicker>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-3 col-4">
              <app-custom-input-decimal formControlName="purchaseValue" [labelText]="'Valor Compra'"
                [required]="true"></app-custom-input-decimal>
            </div>
            <div class="col-lg-3 col-md-5 col-sm-4 col-6">
              <app-custom-input-text formControlName="trademark" [labelText]="'Marca'"
                [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col-lg-3 col-md-5 col-sm-5 col-6">
              <app-custom-input-text formControlName="commercialName" [labelText]="'Denominación Ccial.'"
                [required]="true" [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col-lg-3 col-md-5 col-sm-4 col-6">
              <app-custom-input-text formControlName="reference" [labelText]="'Referencia'" [required]="true"
                [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col-lg-2 col-md-5 col-sm-4 col-6">
              <app-custom-input-text formControlName="serie" [labelText]="'Serie'" [required]="true"
                [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-6">
              <app-custom-input-number formControlName="yearManufacture"
                [labelText]="'Año Fabricación'"></app-custom-input-number>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3 col-6">
              <app-custom-datepicker formControlName="warrantyInitialDate"
                [labelText]="'Fec.Ini.Garantia'"></app-custom-datepicker>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3 col-6">
              <app-custom-datepicker formControlName="warrantyFinalDate"
                [labelText]="'Fec.Fin.Garantia'"></app-custom-datepicker>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-6 col-6">
              <label class="form-label d-block">Adjunto Factura</label>
              <div class="d-flex">
                <div class="btn-attach-invoice">
                  <p-button title="Adjuntar Archivo" icon="pi pi-paperclip" size="small" severity="success"
                    (click)="addAttachInvoice()" [disabled]="disabledAttachAdd" />
                  <input id="files" name="files" #files type="file" (change)="chooseFile($event)" hidden>
                </div>
                <div class="btn-attach-invoice">
                  <p-button title="Descargar Adjunto" icon="pi pi-download" size="small" severity="info"
                    (click)="downloadAttachInvoice()" [disabled]="disabledAttachDownloadDelete" />
                </div>
                <div class="btn-attach-invoice">
                  <p-button title="Eliminar Adjunto" icon="pi pi-trash" size="small" severity="danger"
                    (click)="deleteAttachInvoice()" [disabled]="disabledAttachDownloadDelete" />
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
              <p class="p-container">{{invoiceAttachName}}</p>
            </div>
          </div>
        </div>
        <div class="col-md-5 col-12">
          <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="equipmentType" [labelText]="'Tipo de Equipo'"
                [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="voltage" [labelText]="'Voltaje'"
                [maxLength]="20"></app-custom-input-text>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="power" [labelText]="'Potencia'"
                [maxLength]="20"></app-custom-input-text>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="amperage" [labelText]="'Amperaje'"
                [maxLength]="20"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="capacity" [labelText]="'Capacidad'"
                [maxLength]="20"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="engineType" [labelText]="'Tipo de Motor'"
                [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="engineCode" [labelText]="'Código Motor'"
                [maxLength]="20"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="trademarkEngine" [maxLength]="50"
                [labelText]="'Marca Motor'"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="referenceEngine" [maxLength]="50"
                [labelText]="'Referencia Motor'"></app-custom-input-text>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-6">
              <app-custom-input-text formControlName="serieEngine" [maxLength]="50"
                [labelText]="'Serie Motor'"></app-custom-input-text>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-5 col-md-5 col-sm-10 col-12">
            <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
              [maxLength]="500"></app-custom-textarea>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-3 d-flex justify-content-start align-items-end">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12 col-12 d-flex align-items-end gap-1 mt-3">

            <!-- Estrategia Mtto. -->
            <app-custom-button *ngIf="swMaintenanceStrategy" [title]="'Estrategia Mtto.'" [icon]="'pi pi-wrench'"
              [label]="'Estrategia Mtto.'" [severity]="'contrast'" [width]="'8.5rem'"
              (onClick)="openMaintenanceStrategy()"></app-custom-button>

            <app-custom-modal #maintenanceStrategy [label]="'Estrategia Mantenimiento'"
              [header]="'Estrategia Mantenimiento'" [inputs$]="inputsForMaintenanceStrategy$"
              [children]="componentMaintenanceStrategy" [width]="'50vw'" [closable]="true" hidden>
            </app-custom-modal>

            <app-custom-button [title]="'Imprimir HV Simple'" [label]="'Imp.HV.Simple'" [icon]="'pi pi-print'"
              [severity]="'secondary'" [width]="'8rem'" (onClick)="printLogbook(true)"></app-custom-button>
            <app-custom-button [title]="'Imprimir HV Valorizada'" [label]="'Imp.HV.Valoriz.'" [icon]="'pi pi-print'"
              [severity]="'secondary'" [width]="'8rem'" (onClick)="printLogbook(false)"></app-custom-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Impresion Hoja de Vida Simple -->
<app-print-equipment-logbook-simple *ngIf="printLogbookSimple" id="print-equipment-logbook" [companyId]="companyId"
  [formatModel]="formatModel" [printDocument]="true" [equipmentLogbookPrintModel]="equipmentLogbookPrintModel"
  [editFormat]="false" [focusText]="true" (finishLoadingPrintMaintenanceOrder)="finishPrintEquipmentLogbook($event)">
</app-print-equipment-logbook-simple>

<!-- Impresion Hoja de Vida Valorizada -->
<app-print-equipment-logbook-valued *ngIf="!printLogbookSimple" id="print-equipment-logbook-valued"
  [companyId]="companyId" [formatModel]="formatModel" [printDocument]="true"
  [equipmentLogbookPrintModel]="equipmentLogbookPrintModel" [editFormat]="false" [focusText]="true"
  (finishLoadingPrintMaintenanceOrder)="finishPrintEquipmentLogbook($event)">
</app-print-equipment-logbook-valued>